import { render, staticRenderFns } from "./label_edit_Case.vue?vue&type=template&id=ab8e4faa&scoped=true"
import script from "./label_edit_Case.vue?vue&type=script&lang=js"
export * from "./label_edit_Case.vue?vue&type=script&lang=js"
import style0 from "./label_edit_Case.vue?vue&type=style&index=0&id=ab8e4faa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab8e4faa",
  null
  
)

export default component.exports